import { ErrorBase } from "@ihr-radioedit/sdk-network";
export const isGraphQLStdErr = (o) => typeof o === "object" && o.hasOwnProperty("message");
export class GraphQLResponse {
    constructor(data, errors, extensions) {
        this.data = data;
        this.errors = errors;
        this.extensions = extensions;
    }
    static fromResponse({ data, errors, extensions, }) {
        return new GraphQLResponse(data, errors, extensions);
    }
    static fromAxios({ data: { data, errors, extensions }, headers: responseHeaders, status, statusText, }) {
        const ext = {
            ...extensions,
            delegate: {
                ...extensions?.["delegate"],
                status,
                statusText,
                responseHeaders,
            },
        };
        return new GraphQLResponse(data, errors, ext);
    }
    get hasError() {
        return (this.errors?.length ?? 0) > 0;
    }
    hasErrorCondition(condition) {
        return !!this.errors && this.errors.some(err => isGraphQLStdErr(err) && err.message === condition);
    }
}
export class GraphQLError extends ErrorBase {
    constructor(message, response) {
        super(message);
        this.message = message;
        this.response = response;
        this.name = "GraphQL Error";
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, GraphQLError);
        }
    }
}
//# sourceMappingURL=response.js.map